mutation RegisterAuthyUser($mfaPhone: String!) {
  registerAuthyUser(mfaPhone: $mfaPhone) {
    user {
      id
      name
    }
    errors
  }
}
